const NUMBER_FOR_SEPARATORS = 12345.6;

export const countDecimalPlaces = (number, decimalSeparator = ",") => {
    if (!number) {
        return 0;
    }
    let value = number;

    if (typeof number === "string") {
        const INPUT_REGEX_REPLACE = new RegExp(`[^0-9${decimalSeparator}]`, "g");
        value = value.replace(INPUT_REGEX_REPLACE, "");
    } else {
        value = `${value}`.replace(".", decimalSeparator);
    }

    return value && value % 1 !== 0 ? `${value}`.split(decimalSeparator)[1]?.length : 0;
};

export const numberFormat = (lang) => {
    const localeString = NUMBER_FOR_SEPARATORS.toLocaleString(lang || undefined);

    const decimalSeparatorIndex = Math.max(localeString?.lastIndexOf("."), localeString?.lastIndexOf(","));
    const thousandSeparatorIndex = Math.min(localeString?.lastIndexOf("."), localeString?.lastIndexOf(","));

    return {
        decimalSeparator: localeString[decimalSeparatorIndex],
        thousandSeparator: localeString[thousandSeparatorIndex],
    };
};

export const toNumber = (str, decimalSeparator = ",", precision = 2, allowNegative = false) => {
    const regExpresion = allowNegative ? `[^-?0-9${decimalSeparator}]` : `[^0-9${decimalSeparator}]`;
    const INPUT_REGEX_REPLACE = new RegExp(regExpresion, "g");

    return str && str !== "" && str !== null
        ? parseFloat(parseFloat(str.replace(INPUT_REGEX_REPLACE, "").replace(decimalSeparator, ".")).toFixed(precision))
        : str;
};

export const formatNumberAR = (number, maximumFractionDigits = 2, minimumFractionDigits = 2) => {
    if (number !== null) {
        return number.toLocaleString('es-AR', {
            maximumFractionDigits,
            minimumFractionDigits,
        });
    }
    return null;
};

export const clamp = (n, min, max) => Math.max(Math.min(n, max), min);

export const getSafeRandomNumber = () => {
    const crypto = window.crypto || window.msCrypto;
    const array = new Uint32Array(1);

    return crypto.getRandomValues(array)[0];
};

export const formatAmountStrDouble = (str, decimalSeparator = ".", thousandSeparator) => {
    let result = parseFloat(str).toFixed(2);

    if (thousandSeparator) {
        const formattedIntegerPart = result
            .split(decimalSeparator)[0]
            .replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);

        result = `${formattedIntegerPart},${result.split(decimalSeparator)[1]}`;
    } else {
        result = result.replace(decimalSeparator, ",");
    }

    return result;
};

export const sumAllTypeValues = (items, prop, name) =>
    items.reduce((a, b) => {
        if (b[prop] === name && !Number.isNaN(b.value)) {
            return a + b.value;
        }
        return a;
    }, 0);

export const sumAllValues = (items, prop) =>
    items.reduce((a, b) => {
        if (!Number.isNaN(b[prop])) {
            return a + b[prop];
        }
        return a;
    }, 0);
